import { POST_EVENTS, LINKS } from 'ggApp/modules/inwebview_api/constants';

type EventsByLinkType = { [key in LINKS]: Event };

export const eventsByLink: EventsByLinkType = {
    [LINKS.CARD]: POST_EVENTS.REDIRECT_TO_CARD_TAB,
};
